<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="value ? value.toISOString().substr(0, 10) : null"
                :label="label || name"
                :name="name"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                @click:append="menu = true"
                v-on="on"
                background-color="#f8f8fd"
                color="primary"
                outlined
                autocomplete="off"
                :error-messages="errorMessages"
            />
        </template>
        <v-date-picker
            validate-on-blur
            color="primary"
            :value="value ? value.toISOString().substr(0, 10) : null"
            @change="onChange"
            :min="min_date"
        ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    props: {
        minDate: Date,
        name: String,
        label: String,
        value: Date,
        errorMessages: {
           type: String,
           default: null,
        },
    },
    data() {
        return {
            date: null,
            menu: false,
        };
    },
    computed: {
        min_date() {
            return this.minDate ? this.minDate.toISOString().substr(0, 10) : null;
        },
    },
    methods: {
        onChange(e) {
            this.menu = false;
            this.$emit('input', new Date(e));
        },
    },
}
</script>
